const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/$lang/garimpos/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/$lang/garimpos/index.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { formatCuratedCrateName } from "@/components/curated-crate-name";
import { buildGarimposHead } from "@/features/garimpos/garimpos-head";
import { buildGarimposTimeline, garimposTimelineCrates } from "@/features/garimpos/garimpos-timeline";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_app/$lang/garimpos/")({
  loaderDeps: () => ({}),
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: async ({
    match,
    loaderData
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const t = createTranslator({
      locale,
      messages,
      namespace: "garimpos"
    });
    const translators = {
      garimpos: t,
      genres: createTranslator({
        locale,
        messages,
        namespace: "shared.genres"
      }),
      styles: createTranslator({
        locale,
        messages,
        namespace: "shared.styles"
      })
    };
    const timeline = buildGarimposTimeline((loaderData?.crateIds ?? []).map(id => ({
      id
    })));
    return await buildGarimposHead({
      locale,
      title: t("seoTitle"),
      description: t("seoDescription"),
      crates: garimposTimelineCrates(timeline),
      crateName: crate => formatCuratedCrateName(crate, translators)
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});